const types = {
  SET_NAV_ACTIVE: "SET_NAV_ACTIVE",
  SET_BOTTOM_TYPE: "SET_BOTTOM_TYPE",
  SET_BOTTOM_DETAIL: "SET_BOTTOM_DETAIL",
  SET_BOTTOM_MENU_ACTIVE: "SET_BOTTOM_MENU_ACTIVE",
  SET_CREATE_BOOKING: "SET_CREATE_BOOKING",
  SET_SAVE_PET: "SET_SAVE_PET",
  SET_MASK: "SET_MASK",
  SET_CHANGE_STATUS: "SET_CHANGE_STATUS",
  SET_UPLOADING: "SET_UPLOADING",
  RESET_UPLOADING: "RESET_UPLOADING",
};

const module = {
  namespaced: true,
  state: {
    booking: {
      _id: "",
      dateTime: 0,
    },
    pet: {
      userID: "",
      _id: "",
      created: 0,
    },
    nav: {
      active: "",
    },
    bottom: {
      type: "",
      detail: {
        arrowIcon: false,
        backText: "返回",
        backUrl: "",
        title: "",
      },
      menu: {
        active: "",
      },
    },
    maskVisible: false,
    changeError: false,
    changeRetryAfter: 0,
    changeRepairing: false,
    uploading: {},
  },
  actions: {
    actionSetNavActive({ commit }, active = "") {
      commit(types.SET_NAV_ACTIVE, active);
    },
    actionSetBottomType({ commit }, type = "") {
      commit(types.SET_BOTTOM_TYPE, type);
    },
    actionSetBottomDetail(
      { commit },
      { arrowIcon = false, backText = "返回", backUrl = "", title = "" }
    ) {
      commit(types.SET_BOTTOM_DETAIL, {
        arrowIcon: arrowIcon,
        backText: backText,
        backUrl: backUrl,
        title: title,
      });
    },
    actionSetBottomMenuActive({ commit }, active = "") {
      commit(types.SET_BOTTOM_MENU_ACTIVE, active);
    },
    actionSetCreateBooking({ commit }, booking) {
      commit(types.SET_CREATE_BOOKING, booking);
    },
    actionSetSavePet({ commit }, pet) {
      commit(types.SET_SAVE_PET, pet);
    },
    actionSetMask({ commit }, maskVisible) {
      commit(types.SET_MASK, maskVisible);
    },
    actionSetChangeStatus({ commit }, payload) {
      commit(types.SET_CHANGE_STATUS, payload);
    },
    actionSetUploading({ commit }, payload) {
      commit(types.SET_UPLOADING, payload);
    },
    actionResetUploading({ commit }, payload) {
      commit(types.RESET_UPLOADING, payload);
    },
  },
  mutations: {
    [types.SET_NAV_ACTIVE](state, active) {
      state.nav.active = active;
    },
    [types.SET_BOTTOM_TYPE](state, type) {
      state.bottom.type = type;
    },
    [types.SET_BOTTOM_DETAIL](state, detail) {
      state.bottom.detail = detail;
    },
    [types.SET_BOTTOM_MENU_ACTIVE](state, active) {
      state.bottom.menu.active = active;
    },
    [types.SET_CREATE_BOOKING](state, booking) {
      state.booking = booking;
    },
    [types.SET_SAVE_PET](state, pet) {
      state.pet = pet;
    },
    [types.SET_MASK](state, maskVisible) {
      state.maskVisible = maskVisible;
    },
    [types.SET_CHANGE_STATUS](state, payload) {
      const { visible: changeError, second: changeRetryAfter = 0, repairing: changeRepairing = false } = payload;
      state.changeError = changeError;
      state.changeRetryAfter = changeRetryAfter;
      state.changeRepairing = changeRepairing;
    },
    [types.SET_UPLOADING](state, { record, type, uploading }) {
      if (state.uploading[record]) {
        state.uploading[record][type] = uploading;
      } else {
        let item = {};
        item[type] = uploading;
        state.uploading[record] = item;
      }
    },
    [types.RESET_UPLOADING](state, { record, type }) {
      delete state.uploading[record][type];
    },
  },
};

export default module;
